export type AccountSchema = {
    FirstName: string,
    MiddleName: string,
    LastName: string,
    PhoneNumber: string,
    Email: string,
    DOB: string,
    SchoolID: string,
    TimeZone: string,
};

const nameofAccountSchemaFirstName = "FirstName";
const nameofAccountSchemaMiddleName = "MiddleName";
const nameofAccountSchemaLastName = "LastName";
const nameofAccountSchemaPhoneNumber = "PhoneNumber";
const nameofAccountSchemaEmail = "Email";
const nameofAccountSchemaDOB = "DOB";
const nameofAccountSchemaSchoolID = "SchoolID";
const nameofAccountSchemaTimeZone = "TimeZone";
const nameofAccountSchemaCollection = "Account";

export {
    nameofAccountSchemaFirstName,
    nameofAccountSchemaMiddleName,
    nameofAccountSchemaLastName,
    nameofAccountSchemaPhoneNumber,
    nameofAccountSchemaEmail,
    nameofAccountSchemaDOB,
    nameofAccountSchemaSchoolID,
    nameofAccountSchemaTimeZone,
    nameofAccountSchemaCollection,
};

export type AccountView = AccountSchema & {
    Id: string,
};
